import { Deserializable } from "../shared/models/deserializable.model";
import { Contact } from "../models/contact";
import { Business } from "../models/business";
import { Property } from "../models/property";
import { Job } from "../models/job";

export class Appointment implements Deserializable {
  accountId: number;
  id: number;
  allDay: boolean;
  title: string;
  description: string;
  startTime: Date;
  endTime: Date;
  createdAt: Date;
  updatedAt: Date;
  contactId: number;
  businessId: number;
  propertyId: number;
  jobId: number;
  completed: boolean;
  completedDate: Date;
  completedBy: number;
  Contact: Contact;
  Business: Business;
  Property: Property;
  Job: Job;
  reminders: number[]; // Array of integers representing reminder lead times in minutes

  constructor() {
    this.completed = false;
    this.reminders = [];
  }

  deserialize(input: any): this {
    Object.assign(this, input);

    // Date objects
    this.startTime = new Date(Date.parse(input.startTime));
    this.endTime = new Date(Date.parse(input.endTime));
    this.createdAt = new Date(Date.parse(input.createdAt));
    this.updatedAt = new Date(Date.parse(input.updatedAt));

    // Embedded objects
    if (input.Contact) this.Contact = new Contact().deserialize(input.Contact);
    if (input.Business) this.Business = new Business().deserialize(input.Business);
    if (input.Property) this.Property = new Property().deserialize(input.Property);
    if (input.Job) this.Job = new Job().deserialize(input.Job);

    // Reminders
    this.reminders = input.reminders || []; // Default to an empty array if not provided

    return this;
  }

  datesAreOnSameDay = (first: Date | string, second: Date | string): boolean => {
    const date1 = new Date(first);
    const date2 = new Date(second);

    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };
}